import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    testData: [],
    audioPlay: true,
  },
  mutations: {
    setStoreData(state, data) {
      state[data.name] = data.data;
    },
    setAudioPlay(state, data) {
      state.audioPlay = data;
      if (data) {
        audioBg.play()
      } else {
        audioBg.pause()
      }
    }
  },
  actions: {}
});
